// The invite token from an /invite/<token> link, held in memory only.
//
// The landing page strips the token from the address bar as soon as it reads it, so
// it is not left in history, screenshots or a shared URL. Keeping it here (never in
// storage) lets the "Sign in to accept" / "Create account" round trip inside this tab
// come back to the invite. A reload or a new tab loses it on purpose: the signed-in
// user then finds the invite through the in-app notice (GET /me/invites).

let pendingInviteToken: string | null = null

export function setPendingInviteToken(token: string): void {
  pendingInviteToken = token
}

export function getPendingInviteToken(): string | null {
  return pendingInviteToken
}

export function clearPendingInviteToken(): void {
  pendingInviteToken = null
}

/**
 * A post-sign-in return path from `?next=`: only same-origin app paths
 * (`/x`, never `//host` or `/\host`), otherwise null.
 */
export function safeNext(raw: string | null): string | null {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return null
  return raw
}

/** `path` with `?next=` carried over when there is one. */
export function withNext(path: string, next: string | null): string {
  return next ? `${path}?next=${encodeURIComponent(next)}` : path
}
